<template>
    <v-container>

        <v-card hover>
            <v-layout id="searchPlace" align-center class="pa-2">

                <v-text-field
                        v-model="searchAll"
                        append-icon="search"
                        label="Αναζήτηση Συγγραμμάτων"
                        single-line
                        hide-details
                        class="pa-2"
                ></v-text-field>

            </v-layout>
        </v-card>
        <br>

        <SubmitInformationExchange :studentBookId="studentBookId" :book="book"/>



        <v-data-table
                :headers="headers"
                :items="customFilter"
                :loading="loading"
                no-data-text
                :pagination.sync="pagination"
                hide-actions
                item-key="studentBookId"
                class="elevation-6">
            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <td >
                    <v-icon v-if="props.item.status.status == 'DELIVERED' && props.item.exchangable == false"   color="success" medium>lens</v-icon>
                    <v-icon v-else-if="props.item.status.status == 'DELIVERED' && props.item.exchangable == true"  color="warning" medium>lens</v-icon>
                    <v-icon v-else color="#D50000" v-model="props.item.colorFlag" medium>lens</v-icon>
                </td>
                <td>[{{ props.item.id }}], {{props.item.title}}</td>
                <td class="text-xs-start" v-html="util.getExchangeStatusDescription(props.item)"></td>

                <td class="text-xs-start red--text" v-html="util.getExchangeStatusOfGreditBook(props.item)"></td>

                <td class="text-xs-start" v-if="props.item.deliveryProvider == 'Unknown' ">Εκτός Ευδόξου</td>
                <td class="text-xs-start" v-else>Από Εύδοξο</td>

                <td class="text-xs-start">
                    <v-flex sm3 v-if="props.item.status.status == 'DELIVERED' && props.item.type == 'Published' && !props.item.exchangable">
                        <v-tooltip left>
                            <v-btn
                                    @click="exchangeBook(props)"
                                    round
                                    small
                                    slot="activator"
                                    color="secondary">
                                <span class="editButton">Ανταλλαγή</span>
                                <v-icon>swap_horiz</v-icon>
                            </v-btn>
                            <span>Δήλωση συγγράμματος για ανταλλαγή</span>
                        </v-tooltip>
                    </v-flex>

                    <v-flex sm3 v-else-if="props.item.status.status == 'DELIVERED' && props.item.type == 'Published' && props.item.exchangable && (props.item.exchangeDestinationId != null ? props.item.exchangeDestinationId : null) == null">
                        <v-tooltip left>
                            <v-btn
                                   @click="cancelExchangeBook(props)"
                                    round
                                   small
                                    slot="activator"
                                    color="info">
                                <span class="editButton">Ακύρωση</span>
                                <v-icon>undo</v-icon>
                            </v-btn>
                            <span>Ακύρωση ανταλλαγής</span>
                        </v-tooltip>
                    </v-flex>

                    <v-flex sm3 v-else-if="props.item.status.status == 'DELIVERED' && props.item.type == 'Published' && props.item.exchangable && (props.item.exchangeDestinationId != null ? props.item.exchangeDestinationId : null) != null">
                        <v-tooltip left>
                                <v-btn
                                   @click="openInformationDialog(props.item)"
                                    round
                                   small
                                   slot="activator"
                                   color="info">
                                <span class="editButton">Στοιχεία Ανταλλαγής</span>
                            </v-btn>
                            <span>Επισκοπηση στοιχείων ανταλλαγής</span>
                        </v-tooltip>
                    </v-flex>

                    <v-flex sm3 v-else-if="props.item.status.status == 'DELIVERED' && props.item.type == 'ePublished'">
                        <v-tooltip left>
                            <v-btn
                                    @click=""
                                    round
                                    small
                                    slot="activator"
                                    color="secondary">
                                <span class="editButton">Λήψη Βιβλίου</span>
                                <v-icon>cloud_download</v-icon>
                            </v-btn>
                            <span>Λήψη Βιβλίου</span>
                        </v-tooltip>
                    </v-flex>

                </td>

                <td class="text-xs-right" v-if="props.item.deliveryProvider == 'Unknown' ">
                    <v-tooltip left>
                    <v-icon color="error" @click="removeBookFromListForExchange(props.item)" slot="activator">cancel</v-icon>
                        <span>Αφαίρεση συγγράμματος</span>
                    </v-tooltip>
                </td>
                <td class="text-xs-right" v-else>
                </td>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
        </div>

        <div id="wrapper" class="pt-3">
            <div style="float:left;">
            </div>
            <div style="float:left; padding-left: 1em">
                <v-card class="elevation-6">
                    <v-card-title><h5>Επιλέξτε φίλτρα συγγραμμάτων:</h5></v-card-title>
                    <v-divider></v-divider>
                    <v-list dense>
                        <v-list-tile :style="{background: backgroundColorAllBooks()}" @click="setFilterId(0)">
                            <v-list-tile-content>Όλα τα συγγράμματα
                            </v-list-tile-content>
                            <v-list-tile-content class="align-end">
                                <v-icon color="light" medium>lens</v-icon>
                            </v-list-tile-content>
                        </v-list-tile><v-list-tile :style="{background: backgroundColorDelivered()}" @click="setFilterId(1)">
                            <v-list-tile-content>Συγγράμματα που έχετε παραλάβει και είναι στην κατοχή σας
                            </v-list-tile-content>
                            <v-list-tile-content class="align-end">
                                <v-icon color="success" medium>lens</v-icon>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile :style="{background: backgroundColorExchangable()}" @click="setFilterId(2)">
                            <v-list-tile-content>Συγγράμματα που διαθέτετε για ανταλλαγή</v-list-tile-content>
                            <v-list-tile-content class="align-end">
                                <v-icon color="warning" medium>lens</v-icon>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile :style="{background: backgroundColorReturn()}" @click="setFilterId(3)">
                            <v-list-tile-content>Συγγράμματα που έχετε παραλάβει και είτε τα επιστρέψατε ή τα ανταλλάξατε
                            </v-list-tile-content>
                            <v-list-tile-content class="align-end pl-5">
                                <v-icon color="#D50000" medium>lens</v-icon>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card>
            </div>
            <div style="float:right; padding: 1em;">
                <p>
                    Οδηγίες για την ανταλλαγή συγγραμμάτων (Εύδοξος+) μπορείτε να βρείτε <br/>στον παρακάτω σύνδεσμο:
                    <a href="https://eudoxus.gr/files/Eudoxus-Plus_Guide.pdf" target="_blank"><i>Οδηγίες Ανταλλαγής -Εύδοξος+</i></a>
                </p>
            </div>
            <div style="clear:both"></div>
        </div>

    </v-container>
</template>

<script>
    import InformationExchange from "../ExtraComponents/InformationExchange";
    import requests from "../../requests";
    import util from "../../utilities";
    import SubmitInformationExchange from "./SubmitInformationExchange";

    export default {
        name: "BookExchangeComponent",
        components: {SubmitInformationExchange, InformationExchange},
        data() {
            return {
                searchAll: '',
                book: {},
                studentBookId: 0,
                eudoxusId: '',
                title: '',
                authors: '',
                util,
                filterColor:0,
                checkedFilter: 4,
                search: '',
                greenColor: true,
                yellowColor: false,
                redColor: false,
                fab: false,
                items: ['', '', ''],
                value: ['', '', ''],
                loading: false,
                pagination: {},
                headers: [
                    {
                        text: '',
                        value: 'id',
                        sortable: false // green yellow red
                    },

                    {text: 'Σύγγραμμα', align: 'left',sortable: false },
                    {text: 'Κατάσταση', align: 'left',sortable: false },
                    {text: 'Μονάδες', align: 'left',sortable: false },
                    {text: 'Παραλήφθηκαν', align: 'left',sortable: false },
                    {text: 'Ειπιλογές', align: 'center',sortable: false },
                    {text: '', align: 'left',sortable: false }
                    // {text: 'Επιλογές', class: 'left', value: 'choice' ,sortable: false }
                    // {text: '', class: 'right', value: 'choice' ,sortable: false }
                ],
            }
        },
        methods: {
            // remove the book from listForExchange
            removeBookFromListForExchange(book) {

                this.$store.commit('setLoadingModal', true);
                requests.removeBook({studentBookId :book.studentBookId}, book, this.successRemoveBook);
            },
            successRemoveBook(book) {

                var listForExchange = this.$store.getters.listForExchange;

                var index = listForExchange.indexOf(book);
                if (index > -1) {
                    listForExchange.splice(index, 1);
                }
                this.$store.commit('setlistForExchange', listForExchange);
                this.$store.commit('setLoadingModal', false);
            },
            searchInTable() {

            },
            // customFilter(items, filters, filter, headers) {
            //     const cf = new this.$MultiFilters(items, filters, filter, headers);
            //
            //     cf.registerFilter('exchangable', function (exchangable, items) {
            //
            //         return items.filter(item => {
            //             return (item.exchangable == true);
            //         }, true);
            //     });
            // },
            backgroundColorAllBooks(){
                if (this.filterColor == 0) {
                    return '#E0E0E0'
                }
            },
            backgroundColorDelivered() {
                if (this.filterColor == 1) {
                    return '#E0E0E0'
                }
            },
            backgroundColorExchangable() {
                if (this.filterColor == 2) {
                    return '#E0E0E0'
                }
            },
            backgroundColorReturn() {
                if (this.filterColor == 3) {
                    return '#E0E0E0'
                }
            },
            setFilterId(id){
                this.checkedFilter = id;
                this.filterColor = id;
            },
            successPostExchangeBook(){
                this.listOfExchangeBooks()
            },
            exchangeBook(props) {
                this.$store.commit('setLoadingModal', true);
                var exchangeObject = {};
                exchangeObject = {srcExhangable: true, srcStatementBookId: props.item.studentBookId};
                requests.postExchangeBook(exchangeObject , this.successPostExchangeBook);
            },
            cancelExchangeBook(props){
                this.$store.commit('setLoadingModal', true);
                var exchangeObject = {};
                exchangeObject = {srcExhangable: false, srcStatementBookId: props.item.studentBookId};
                requests.postExchangeBook(exchangeObject , this.successPostExchangeBook);
            },
            openInformationDialog(book){
                this.book = book;
                this.studentBookId = book.studentBookId;
                this.$store.commit('setLoadingModal' , true);
                requests.exchangeStudentData(book.exchangeDestinationId, this.callBuckSuccessExchangeStudentData)
            },

            callBuckSuccessExchangeStudentData(response){
                var exchangeStudentData;
                this.$store.commit('setSubmitInformationDialog', true);
                exchangeStudentData = {student: response.student,
                    exchangeDestinationId: response.exchangeDestinationId, statementBookId: response.statementBookId, book: response};
                this.$store.commit('setExchangeStudentData', exchangeStudentData);
                this.$store.commit('setLoadingModal', false);
            },

            callBackSuccessExchangeBooks(response){
                this.$store.commit('setLoadingModal', false);
                this.$store.commit('setlistForExchange', response);
                util.setCounterExchangeBooks();
            },
            listOfExchangeBooks(){
                this.$store.commit('setLoadingModal', true);
                requests.listOfExchangeBooks(this.callBackSuccessExchangeBooks, this.onRequestErrors);
            }
        },
        created(){
            this.listOfExchangeBooks();
        },
        computed: {
            pages() {
                if (this.pagination.rowsPerPage == null ||
                    this.pagination.totalItems == null
                ) return 0;
                if(this.customFilter.length < 5){
                    return 0;
                }
                else {
                    return Math.ceil(this.customFilter.length / this.pagination.rowsPerPage)
                }

            },
            customFilter: function () {

                this.eudoxusId = '';
                this.title = '';

                if (this.searchAll != '' && this.searchAll != null) {
                    if (isNaN(this.searchAll)) {
                        this.title = this.searchAll;
                    }
                    else {
                        this.eudoxusId = this.searchAll;
                    }
                    this.filterColor = null;
                }

                if (this.checkedFilter == 0) {
                    this.checkedFilter = 4;
                    this.searchAll = '';
                    return this.$store.getters.listForExchange
                } else if (this.checkedFilter == 1) {
                    this.checkedFilter = 4;
                    this.searchAll = '';
                    return this.$store.getters.listForExchange.filter((book) => {
                        return (book.exchangable == false && book.status.status == "DELIVERED")
                    })
                } else if (this.checkedFilter == 2) {
                    this.checkedFilter = 4;
                    this.searchAll = '';
                    return this.$store.getters.listForExchange.filter ((book) => {
                        return(book.exchangable == true && book.status.status == "DELIVERED")
                    })
                } else if (this.checkedFilter == 3) {
                    this.checkedFilter = 4;
                    this.searchAll = '';
                    return this.$store.getters.listForExchange.filter ((book) => {
                        return book.status.status == "EXCHANGED"
                    })
                }
                else if (this.checkedFilter == 4) {
                        return this.$store.getters.listForExchange.filter ((book) => {
                            if (this.eudoxusId != '' && this.eudoxusId != null){
                                return book.id.toString().match(new RegExp(this.eudoxusId.toString()));
                            }
                            else if (this.title != '' && this.title != null){
                                return book.title.match(new RegExp(util.searchFunction(this.title), "i"));
                            }
                            else if (this.authors != '' && this.authors != null){
                                return book.authors.match(new RegExp(util.searchFunction(this.authors), "i"));
                            }
                            this.filterColor = 0;
                            return this.$store.getters.listForExchange
                        })
                }
            }
        }
    }
</script>

<style scoped>

    .editButton {
        font-size: small;
        padding-right: 5px;
    }

</style>
